/**
 * Utility functions for patient medical insurance data
 */

/**
 * Get medical insurance number from patient object
 * @param {Object} patient - Patient object
 * @returns {string} Medical insurance number or "N/A"
 */
export function getMedicalInsuranceNumber(patient) {
  if (!patient?.patient) {
    return "N/A";
  }

  // Nueva estructura
  if (patient.patient.medicalInsuranceObj?.number) {
    return patient.patient.medicalInsuranceObj.number;
  }
  // Fallback a estructura antigua
  return patient.patient.medicalInsuranceNumber || "N/A";
}

/**
 * Get medical insurance plan from patient object
 * @param {Object} patient - Patient object
 * @returns {string} Medical insurance plan or "N/A"
 */
export function getMedicalInsurancePlan(patient) {
  if (!patient?.patient) {
    return "N/A";
  }

  // Nueva estructura
  if (patient.patient.medicalInsuranceObj?.plan) {
    return patient.patient.medicalInsuranceObj.plan;
  }

  // Fallback a estructura antigua
  return patient.patient.medicalInsurancePlan || "N/A";
}

/**
 * Get medical insurance name from patient object
 * @param {Object} patient - Patient object
 * @returns {string} Medical insurance name or "N/A"
 */
export function getMedicalInsuranceName(patient) {
  if (!patient?.patient) {
    return "N/A";
  }
  // Nueva estructura
  if (patient?.patient?.medicalInsuranceObj?.publicInsurance?.name) {
    return patient.patient.medicalInsuranceObj.publicInsurance.name;
  }
  // Fallback a estructura antigua
  if (patient?.patient?.medicalInsurance?.name) {
    return patient.patient.medicalInsurance.name;
  }
  return "N/A";
}
